module.exports = __webpack_public_path__ + "img/comforser.d0880fd5.svg";